import { motion } from "framer-motion";
import React from "react";
import { fadeInDown } from "../../utils/animations";

export default function Card({
  children,
  title,
  className = "",
  border = true,
  flex = true,
  cardAction,
}: {
  children: any;
  title?: string;
  className?: string;
  border?: Boolean;
  flex?: Boolean;
  cardAction?: React.ReactNode;
}) {
  return (
    <motion.div
      variants={fadeInDown}
      className={`${className} relative p-8 bg-white  rounded-3xl text-left`}
      style={{
        boxShadow: "0px 5px 20px rgba(0,0,0,0.15)",
      }}
    >
      <div className={`${flex ? `flex flex-col gap-4` : ``}`}>
        {title != null && (
          <div
            className={`${border && `rounded_border_bottom`} items-center pb-2 flex justify-between`}
          >
            <h1 className={`text-xl font-bold text-blue-500 md:text-2xl`}>
              {title}
            </h1>
            {cardAction && cardAction}
          </div>
        )}
        {children}
      </div>
    </motion.div>
  );
}
